import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Directive, forwardRef, ElementRef, HostListener } from '@angular/core';

type ControlValues = string | number | boolean | undefined | null;

/**
 * @description
 * Directive that extends form components to work with Angular Forms.
 * @usageNotes
 * Add the form component to the selector (comma-separated) and import together with the form component.
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'rx-checkbox[formControlName]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RxFormControlDirective),
      multi: true
    }
  ]
})
export class RxFormControlDirective implements ControlValueAccessor {
  disabled: boolean;
  _value: ControlValues;

  constructor(private elementRef: ElementRef) {}

  /**
   * @description
   * Creates event listener on `valueChange` event on the host element
   * In this case the element selected by this directive
   * Dispatched `valueChange` event must be object with detail property
   * containing value
   * @param value value to change form control value with
   */
  @HostListener('valueChange', ['$event.detail'])
  listenForValueChange(value: ControlValues) {
    this.value = value;
  }

  get value() {
    return this._value;
  }

  set value(value) {
    if (value !== this._value) {
      this._value = value;
      this.onChange(this._value);
      this.onTouched();
    }
  }

  writeValue(value: ControlValues) {
    this._value = value;
  }

  registerOnChange(fn: (value: ControlValues) => void) {
    this.onChange = fn;
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  private onChange: (value: ControlValues) => void = () => { /**/ };
  onTouched = () => { /**/ };
}
